import { Component, Vue } from 'vue-property-decorator'
import { queryAbnormalStudentsList } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({ name: 'class-list-page', components: { HighFilter } })
export default class ClassListPage extends Vue {
  private tableData = []
  private totalPage = 100;
  private currentPage = 1;
  private mentorSelectDialogShow = false
  private mentorChoose = ''
  private classChoose = ''
  private mentorList = []
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  created () {
    this.initPageData()
  }

  private async initPageData () {
    const param: any = { page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await queryAbnormalStudentsList(param)
    this.totalPage = result.allPage
    this.currentPage = result.currentPage
    this.tableData = result.studentList
    this.filterData = result.search
  }

  /**
  * [description] 分页切换回调函数
  */
  private async onPageChange () {
    this.initPageData()
  }

  private rowClicked (row: any, column: any, cell: any, event: any) {
    this.$router.push({ path: '/student/detail', query: { id: row.studentId, detailType: '3' } })
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }
}
